import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useContext, useEffect, useCallback, useState } from 'react';
import { useSessionUserInput } from '../user-input-provider';
import { SearchDialogAnalyticsContext, useAnalyticsContext } from '../../common/analytics';
import { useDialogExpansionContext } from '../dialog-expansion-context';
var QueryContext = /*#__PURE__*/React.createContext({
  query: '',
  queryVersion: 0,
  isLoading: false,
  setQuery: function setQuery(ignore) {},
  setQueryOnly: function setQueryOnly(ignore) {},
  setAdditionalAnalyticsContext: function setAdditionalAnalyticsContext(ignore) {
    return {};
  }
});
export var QueryContextProvider = function QueryContextProvider(_ref) {
  var children = _ref.children;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    stateQuery = _useState2[0],
    setStateQuery = _useState2[1];
  var _useSessionUserInput = useSessionUserInput(),
    stickySearchEnabled = _useSessionUserInput.stickySearchEnabled,
    sessionQuery = _useSessionUserInput.query,
    showSearchAIDialog = _useSessionUserInput.showSearchAIDialog,
    toggleShowSearchAIDialog = _useSessionUserInput.toggleShowSearchAIDialog,
    storeQuery = _useSessionUserInput.storeQuery;
  var query = stickySearchEnabled ? sessionQuery : stateQuery;
  var setQuery = useCallback(function (value) {
    if (showSearchAIDialog) {
      toggleShowSearchAIDialog(false);
    }
    stickySearchEnabled ? storeQuery(value) : setStateQuery(value);
  }, [showSearchAIDialog, toggleShowSearchAIDialog, stickySearchEnabled, storeQuery]);
  var setQueryOnly = useCallback(function (value) {
    stickySearchEnabled ? storeQuery(value) : setStateQuery(value);
  }, [stickySearchEnabled, storeQuery]);
  var _useDialogExpansionCo = useDialogExpansionContext(),
    isExpanded = _useDialogExpansionCo.isExpanded;
  var _useAnalyticsContext = useAnalyticsContext(query),
    isLoading = _useAnalyticsContext.isLoading,
    setAdditionalAnalyticsContext = _useAnalyticsContext.setAdditionalAnalyticsContext,
    addAnalyticContext = _useAnalyticsContext.addAnalyticContext,
    nonPrivacySafeContext = _useAnalyticsContext.nonPrivacySafeContext,
    queryVersion = _useAnalyticsContext.queryVersion;
  useEffect(function () {
    if (!isExpanded) {
      if (!stickySearchEnabled) {
        setQuery('');
      }
      setAdditionalAnalyticsContext({
        type: 'reset'
      });
    }
  }, [isExpanded, setAdditionalAnalyticsContext, stickySearchEnabled, setQuery]);
  return /*#__PURE__*/React.createElement(QueryContext.Provider, {
    value: {
      query: query,
      queryVersion: queryVersion,
      setQuery: setQuery,
      setQueryOnly: setQueryOnly,
      setAdditionalAnalyticsContext: setAdditionalAnalyticsContext,
      isLoading: isLoading
    }
  }, /*#__PURE__*/React.createElement(SearchDialogAnalyticsContext, {
    analyticContext: addAnalyticContext,
    nonPrivacySafeAnalyticContextGenerator: nonPrivacySafeContext
  }, children));
};
export var useQuery = function useQuery() {
  return useContext(QueryContext);
};